/* 🤖 this file was generated by svg-to-ts */
export const matIconCurtainsClosed: {
  name: 'curtains-closed';
  data: string;
} = {
  name: 'curtains-closed',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 19V3H4v16H2v2h20v-2h-2zM13 5v14h-2V5h2zM6 5h3v14H6V5zm9 14V5h3v14h-3z"/></svg>`
};
